  
// var elements = document.getElementsByClassName("product-item");
// Array.from(elements).forEach(function(element){
//   element.addEventListener('mouseover', function(){
//    hoverImg(this)
//   });
//   element.addEventListener('mouseleave', function(){
//    exitHover(this)
//   }); 
// });
 
// function hoverImg(val){
//   if(val.children[0].children[0].childNodes[3].classList.contains('product-img-hover')){
//     val.children[0].children[0].childNodes[1].classList.remove('show');
//     val.children[0].children[0].childNodes[1].classList.add('hide');
//     val.children[0].children[0].childNodes[3].classList.add('show');
//     val.children[0].children[0].childNodes[3].classList.remove('hide');
//   }
// }

// function exitHover(val){
//   if(val.children[0].children[0].childNodes[3].classList.contains('product-img-hover')){
//     val.children[0].children[0].childNodes[1].classList.remove('hide');
//     val.children[0].children[0].childNodes[1].classList.add('show');
//     val.children[0].children[0].childNodes[3].classList.add('hide');
//     val.children[0].children[0].childNodes[3].classList.remove('show');
//   }
// }



$(function() {
  
  document.querySelectorAll(".product-item").forEach(function(el){
    $(el).on('click', function() {
      $(this).children("a").click();
    })
  });


  


  // productHover(document);
  


  var filterTl = gsap.timeline({ paused: true, reversed: true });

  filterTl.fromTo('.filter-popup', {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    duration: .3,
  })
  
  if(window.innerWidth > 768) {
    filterTl.fromTo('.filter-popup .title, .filter-popup .checkmark-container, .filter-popup .filter-clear-all', {
      autoAlpha: 0,
      y: 15,
    }, {
      autoAlpha: 1,
      y: 0,
      duration: .25,
      stagger: .04
    });
  }

  document.querySelector("a.product-filter").addEventListener("click", function () {
  const filterLink = this;

  if (filterTl.reversed()) {
    filterTl.play();
    filterLink.classList.add("active");
    filterLink.setAttribute("aria-expanded", "true");
  } else {
    filterLink.classList.remove("active");
    filterLink.setAttribute("aria-expanded", "false");
    filterTl.reverse();
  }
});




});



// $(".product-filter").click(function(){
//   $(".filter-popup").toggle();
// });

var urlSearchParams = new URLSearchParams(window.location.search);
var params = Object.fromEntries(urlSearchParams.entries());

// function myFunction1() {
//   var x = document.querySelector(".filter-popup");
  
  
//   if (x.style.display === "none") {
//     x.style.display = "block";
//     x.classList.remove('closed');
//     document.querySelector('.filter-open').classList.remove('active')
//     setTimeout(()=>{
//     document.querySelector('.filter-close').classList.add('active')
//   },50)
//   } else {
//     x.style.display = "none";
//     x.classList.add('closed');
//     setTimeout(()=>{
//     document.querySelector('.filter-open').classList.add('active')
//     },50)
//     document.querySelector('.filter-close').classList.remove('active')
//   }
  
// }


function checkCheckboxes(val){

var allCheckBoxes = document.querySelectorAll(".filter-popup input[type='checkbox']")
for (var i = 0; i < allCheckBoxes.length; i++) {
  var cb = allCheckBoxes[i];
  if(val == 'hide'){
    if(cb.checked){
      Array.from(document.querySelectorAll('.grid-testimonial, .grid-image-2-col, .collection-content-tile')).forEach(x=>{
//         x.style.opacity = '0';
//         x.style.visibility = 'hidden';
//         x.style.width = '0';
        
        x.style.opacity = "0";
        x.style.position = "absolute";
        x.style.visibility = 'hidden';
        x.style.top = "-1000px";
      })
      break;
    }
    
    if(i == allCheckBoxes.length-1){
      Array.from(document.querySelectorAll('.grid-testimonial, .grid-image-2-col, .collection-content-tile')).forEach(x=>{
//         x.style.opacity = '1';
//         x.style.visibility = 'visible';
//         x.style.width = '50%';
        
        x.style.opacity = "1";
        x.style.position = "relative";
        x.style.visibility = 'visible';
        x.style.top = "0";
      })
    }
  }else if(val == 'clear'){
    window.history.pushState({}, document.title, window.location.pathname);
  	cb.checked = false;
    
    var event = new Event('change');
    // Dispatch it.
    cb.dispatchEvent(event);
  }
}
}

function change() {
  var modelCbs = document.querySelectorAll("#group-category input[type='checkbox']");
  var modelCbs1 = document.querySelectorAll("#group-for input[type='checkbox']");
  var modelCbs2 = document.querySelectorAll("#group-concern input[type='checkbox']");
  
  var filters = {
    category: getClassOfCheckedCheckboxes(modelCbs),
    for: getClassOfCheckedCheckboxes(modelCbs1),
    concern: getClassOfCheckedCheckboxes(modelCbs2)
  };

  filterResults(filters);
  checkCheckboxes('hide');
  
  var url='?', count = 0;
  
  document.querySelectorAll('.filter-popup input:checked').forEach((x)=>{
    url += x.getAttribute('rel')+'=true&';
    count++
  })
  
  if(count == 0){
  	window.history.pushState({}, document.title, window.location.pathname);
  }else{
	url = url.slice(0, -1);
	window.history.pushState( {} , '', url )
  }

  locoScroll.update();
}

function getClassOfCheckedCheckboxes(checkboxes) {
  var classes = [];

  if (checkboxes && checkboxes.length > 0) {
    for (var i = 0; i < checkboxes.length; i++) {
      var cb = checkboxes[i];

      if (cb.checked) {
        classes.push(cb.getAttribute("rel")+'-tag');
      }
    }
  }

  return classes;
}

function filterResults(filters) {
  var rElems = document.querySelectorAll(".product-grid .product-item");
  var hiddenElems = [];
 
  if (!rElems || rElems.length <= 0) {
    return;
  }

  for (var i = 0; i < rElems.length; i++) {
    var el = rElems[i];

    if (filters.category.length > 0) {
      var isHidden = true;

      for (var j = 0; j < filters.category.length; j++) {
        var filter = filters.category[j];

        if (el.classList.contains(filter)) {
          isHidden = false;
          break;
        }
      }

      if (isHidden) {
        hiddenElems.push(el);
      }
    }
    
    if (filters.for.length > 0) {
      var isHidden = true;

      for (var j = 0; j < filters.for.length; j++) {
        var filter = filters.for[j];

        if (el.classList.contains(filter)) {
          isHidden = false;
          break;
        }
      }

      if (isHidden) {
        hiddenElems.push(el);
      }
    }
    
    if (filters.concern.length > 0) {
      var isHidden = true;

      for (var j = 0; j < filters.concern.length; j++) {
        var filter = filters.concern[j];

        if (el.classList.contains(filter)) {
          isHidden = false;
          break;
        }
      }

      if (isHidden) {
        hiddenElems.push(el);
      }
    }
  }

  for (var i = 0; i < rElems.length; i++) {
    console.log((rElems[i]))
    rElems[i].style.opacity = "1";
    rElems[i].style.position = "relative";
    rElems[i].style.visibility = 'visible';
	rElems[i].style.top = "0";
//     $('#'+rElems[i].id).fadeIn(250)
  }

  if (hiddenElems.length <= 0) {
    return;
  }

  for (var i = 0; i < hiddenElems.length; i++) {
    console.log((hiddenElems[i]))
    hiddenElems[i].style.opacity = "0";
    hiddenElems[i].style.visibility = 'hidden';
    hiddenElems[i].style.position = "absolute";
    hiddenElems[i].style.top = "-1000px";
//     $('#'+hiddenElems[i].id).fadeOut(200)
//     hiddenElems[i].style.display = "none";

  }
}

$('.filter-popup .group').on('click', function(){
  document.querySelectorAll('.filter-popup .group').forEach(x=>{
  	x.classList.remove('active');
  })
	$(this).addClass('active');
})

  
for (var key in params) {
  document.querySelector(`[rel='${key}']`).click()
}
